/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Agent_Builder_Result_Action_Dataset_PlaceholderInputs */



/**
* | output |
* | --- |
* | "Pick a dataset" |
*
* @param {Agent_Builder_Result_Action_Dataset_PlaceholderInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const agent_builder_result_action_dataset_placeholder = /** @type {((inputs?: Agent_Builder_Result_Action_Dataset_PlaceholderInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Agent_Builder_Result_Action_Dataset_PlaceholderInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Datensatz auswählen")
	return /** @type {LocalizedString} */ ("Pick a dataset")
});